import { HttpClient } from './HttpClient';
import { getApiUrl } from './UrlBuilder';

import { SocialMedia } from 'models/Social';

import { UserManager, HALManager } from 'core';

export class SocialMediaService {
  private httpClient: HttpClient = new HttpClient();

  public async getSocialMedia() {
    const urlRequest = getApiUrl(HALManager.getSocialMediaUrl(UserManager.userId));

    const response = await this.httpClient.get<SocialMedia>(urlRequest);

    return response.object;
  };

  public async updateSocialMedia(model: SocialMedia) {
    const urlRequest = getApiUrl(HALManager.updateSocialMediaUrl(UserManager.userId));

    const requestParams = { body: JSON.stringify(model) };

    const response = await this.httpClient.put<SocialMedia>(urlRequest, requestParams);

    return response.object;
  };
}

export default new SocialMediaService();
